<template>
    <img :class="rootClasses"
            :src="src"
            :srcset="srcSet"
            :alt="alt">
</template>
<script>
    import { srcsetFilter } from '@dreipol/vue-ui/src/filters';
    import bemMixin from '@dreipol/vue-ui/src/mixins/bem';
    import interactionObserverMixin from '@dreipol/vue-ui/src/mixins/intersection-observer';
    import bestPictureMixin from 'framework/mixins/best-picture/index';
    import imageDpiResolution from '../../../util/dom/device-dpi-resolution';
    import { isResponsiveImgSupported } from '../../../util/dom/support';

    const srcSetEnabled = isResponsiveImgSupported();

    export default {
        components: {},
        mixins: [
            bestPictureMixin,
            interactionObserverMixin,
            bemMixin('picture-element'),
        ],
        props: {
            alt: {
                type: String,
                default: '',
            },
            lazy: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                isVisible: window.matchMedia('print').matches,
            };
        },
        computed: {
            srcSet() {
                return this.isVisible && srcSetEnabled ? srcsetFilter(this.bestPicture) : '';
            },
            src() {
                // We can omit the default src if we don't want to lazyload
                // AND if the browser (all non-IE) supports it. This way
                // the `srcset` will decide, wich image to load.
                if (srcSetEnabled && !this.lazy) {
                    return '';
                }
                const imageSet = this.isVisible || !this.lazy ? this.bestPicture : this.urls.lazy || this.urls.default; // fall back to default if lazy is not provided
                const deviceResolution = imageDpiResolution();
                return imageSet && imageSet[deviceResolution] ? imageSet[deviceResolution] : imageSet[0];
            },
            rootClasses() {
                return [
                    this.bemRoot,
                    this.bemIf(this.isVisible || !this.lazy, 'is-visible', 'is-blurry'),
                ];
            },
        },
        methods: {
            onIntersectEnter() {
                this.isVisible = true;
                this.kill();
            },
            kill() {
                this.unregister(this.$el);
            },
        },
        mounted() {
            this.registerObserver(this.$el, 0.1);
        },
        beforeDestroy() {
            this.kill();
        },
    };
</script>
